import { apiSlice } from "features/api/apiSlice";
import { transformUser } from "./transformUser";

const getUser = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getUser: build.query({
      query: () => "/auth/me",
      transformResponse: (res) => transformUser(res.d),
      providesTags: ["User"],
    }),
  }),
});

export const { useGetUserQuery } = getUser;
